<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    협의체 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>점검 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>점검기간</div>
          <span v-if="isPrint" class="print-input"> {{form.점검기간_시작}} - {{form.점검기간_종료}} </span>
          <div v-else class="flex flex-1 items-center">
            <date-selector class="w-full" v-model="form.점검기간_시작" :readonly="board.readonly"/>
            <div class="ml-4 mr-4">~</div>
            <date-selector class="w-full" v-model="form.점검기간_종료" :readonly="board.readonly"/>
          </div>
        </div>
      </div>

      <h5 class="mt-8 mb-4"><i class="dot"></i>주요 유해·위험요인 확인</h5>
      <div>
        <table class="summary-table w-full">
          <thead>
            <tr>
              <th rowspan="2">점검횟수</th>
              <th colspan="3">조치 여부</th>
              <th rowspan="2">비고</th>
            </tr>
            <tr>
              <th>완료</th>
              <th>추진 중</th>
              <th>미추진</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div v-if="isPrint" class="print-input">{{ form.점검횟수 }} 회</div>
                <div v-else class="flex flex-1 flex-row items-center">
                  <number-input v-model="form.점검횟수" :readonly="board.readonly" class="w-full" :min="0" />
                  <div class="ml-2">회</div>
                </div>
              </td>
              <td>
                <span v-if="isPrint" class="print-input">{{ form.조치여부_완료 }} 건</span>
                <div v-else class="flex flex-1 flex-row items-center">
                  <number-input v-model="form.조치여부_완료" :readonly="board.readonly" class="w-full" :min="0" />
                  <div class="ml-2">건</div>
                </div>
              </td>
              <td>
                <span v-if="isPrint" class="print-input">{{ form.조치여부_추진중 }} 건</span>
                <div v-else class="flex flex-1 flex-row items-center">
                  <number-input v-model="form.조치여부_추진중" :readonly="board.readonly" class="w-full" :min="0" />
                  <div class="ml-2">건</div>
                </div>
              </td>
              <td>
                <span v-if="isPrint" class="print-input">{{ form.조치여부_미추진 }} 건</span>
                <div v-else class="flex flex-1 flex-row items-center">
                  <number-input v-model="form.조치여부_미추진" :readonly="board.readonly" class="w-full" :min="0" />
                  <div class="ml-2">건</div>
                </div>
              </td>
              <td>
                <div v-if="isPrint" class="print-input">{{ form.비고 }}</div>
                <ml-input v-else v-model="form.비고" :readonly="board.readonly" :max="1000" visibleCounter />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 class="mt-8 mb-4"><i class="dot"></i>주요 조치사항</h5>
      <div>
        <p v-if="isPrint" class="print-textarea">{{ form.주요조치사항 }}</p>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.주요조치사항" :readonly="board.readonly" />
      </div>

      <div class="mt-8 flex flex-row justify-between items-center">
        <h5><i class="dot"></i>점검결과 및 조치사항</h5>
        <div v-if="!board.readonly && !isPrint">
          <vs-button color="secondary" @click="onAddResult"> 추가 </vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onRemoveResult"> 삭제 </vs-button>
        </div>
      </div>
      <div class="result-container w-full" v-for="(item, item_i) in form.점검결과" :key="`result_${item_i}`">
        <!--1번째 컬럼-->
        <div>
          <div v-if="isPrint || board.readonly" class="mt-4">
            <div class="result-photo-container">
              <img v-if="item.beforePhotoList && item.beforePhotoList[0]"
                   :src="item.beforePhotoList[0].path"
                   alt="개선 전 사진"
                   class="result-photo">
            </div>
          </div>
          <div v-else>
            <PhotoUploadGridModule :row-count="1" :grid-count="1" v-model="item.beforePhotoList" :isPrint="isPrint"
                                   :readonly="board.readonly" :is-show-title="false" :show-footer-input="false"
                                   :is-check-mode="false"/>
          </div>
          <div class="flex flex-row w-full items-center gap-3 mt-4">
            <div class="result-tag" style="background-color: #ff9f43">개선 전</div>
            <div> 개선 전 점검내용</div>
            <div class="w-full">
              <div v-if="isPrint" class="print-input">{{ item.beforeContent }}</div>
              <ml-input v-else v-model="item.beforeContent" class="w-full" :readonly="board.readonly" />
            </div>
          </div>
        </div>

        <!--2번째 컬럼-->
        <div>
          <div v-if="isPrint || board.readonly" class="mt-4">
            <div class="result-photo-container">
              <img v-if="item.afterPhotoList && item.afterPhotoList[0]"
                   :src="item.afterPhotoList[0].path"
                   alt="개선 후 사진"
                   class="result-photo">
            </div>
          </div>
          <div v-else>
            <PhotoUploadGridModule :row-count="1" :grid-count="1" v-model="item.afterPhotoList" :isPrint="isPrint"
                                   :readonly="board.readonly" :is-show-title="false" :show-footer-input="false"
                                   :is-check-mode="false"/>
          </div>
          <div class="flex flex-row w-full items-center gap-3 mt-4">
            <div class="result-tag" style="background-color: #00CFE8">개선 결과</div>
            <div> 개선 완료(예정) 내용</div>
            <div class="w-full">
              <div v-if="isPrint" class="print-input">{{ item.afterContent }}</div>
              <ml-input v-else v-model="item.afterContent" class="w-full" :readonly="board.readonly" />
            </div>
          </div>
          <div class="flex flex-row w-full items-center gap-3 mt-3">
            <div class="result-tag" style="visibility: hidden">개선 결과</div>
            <div> 개선 완료(예정) 일자</div>
            <div class="w-full">
              <div v-if="isPrint" class="print-input">{{ item.afterDate }}</div>
              <date-selector v-else v-model="item.afterDate" class="w-full" :readonly="board.readonly" />
            </div>
          </div>
        </div>
      </div>

      <h5 class="mt-8 mb-4"><i class="dot"></i>향후 관리계획</h5>
      <div>
        <p v-if="isPrint" class="print-textarea">{{ form.향후관리계획 }}</p>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.향후관리계획" :readonly="board.readonly" />
      </div>
    </div>
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import TableRiskAssemblyRecord from "@/components/TableRiskAssemblyRecord.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import SignField from "@/components/SignField.vue";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    NumberInput,
    SignField,
    DisasterClassSelector,
    TableRiskAssemblyRecord,
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],
        점검기간_시작: '',
        점검기간_종료: '',
        참석자: '',
        주요조치사항: '',
        점검결과_및_조치사항: '',
        점검횟수: 0,
        조치여부_완료: 0,
        조치여부_추진중: 0,
        조치여부_미추진: 0,
        비고: '',
        점검결과: [
          {
            beforePhotoList: [],
            beforeContent: '',
            afterPhotoList: [],
            afterContent: '',
            afterDate: '',
          }
        ],
        향후관리계획: '',
      },
    };
  },
  methods: {
    // 점검결과 항목 추가
    onAddResult() {
      if (this.board.readonly) return;

      this.form.점검결과.push({
        beforePhotoList: [],
        beforeContent: '',
        afterPhotoList: [],
        afterContent: '',
        afterDate: '',
      });
    },
    // 점검결과 항목 삭제 (마지막 항목 삭제)
    onRemoveResult() {
      if (this.board.readonly) return;

      // 최소 1개 항목은 유지
      if (this.form.점검결과.length > 1) {
        this.form.점검결과.pop();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.summary-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #cdcdcd;

  th, td {
    font-size: 14px;
    text-align: center;
  }
  th {
    font-weight: 700;
    padding: 16px;
    border: 1px solid #cdcdcd;
    background-color: #f9f9f9;
  }
  td {
    padding: 10px;
    border: 1px solid #cdcdcd;
  }
  // 마지막 td를 제외
  td:not(:last-child) {
    width: 14%;
    min-width: 150px;
  }
}

.result-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  font-size: 14px;
  color: #3c3c3c;
  font-weight: 500;
  white-space: nowrap;

  .result-tag {
    border-radius: 4px;
    padding: 6px;
    color: white;
    font-size: 14px;
    font-weight: 700;
  }
}

.result-photo-container {
  width: 100%;
  aspect-ratio: 4/3;
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f9f9f9;

  .result-photo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
}
</style>
